module.exports = __webpack_public_path__ + "img/sports_grid_mob.e7cb4ec9.svg";